import React from 'react'
import NormalTable from './NormalTable'
import { Paper } from '@mui/material'

const RemarkTableView = ({data}) => {
  console.log(data)
    const column=[
        {
            Header:"Name",
            accessor:"name"
        },
        // {
        //     Header:"Role",
        //     accessor:"role"
        // },
        {
            Header:"Remark",
            accessor:"remark"
        },
    ]
  return (
    <Paper elevation={1}>
    {data!==null&&data!==undefined?
    <NormalTable data={
        [{
            role:data.split("@$/")[1],
            name:data.split("@$/")[0],
            remark:data.split("@$/")[2],
        }]
    }
    columns={column}
    />:null}
    </Paper>
  )
}

export default RemarkTableView




